import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import whatwedoimage1 from "../../assets/images/WhatwedoImage.png";
import whatwedo1 from "../../assets/images/Whatwedo/whatwedo1.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhatwedoContent = () => {

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "0rem 0rem 0rem 0rem",
        display: "flex",
        justifyContent: { xs: "start", sm: "flex-start" },
        alignItems: "center",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box sx={{ width: { xs: "80%", sm: "55%", md: "40%" },}}>
        <Box sx={{ width: { xs: "auto", md: "30rem" } }}>
          <LazyLoadImage
            src= {isMdUp ? whatwedoimage1 : whatwedo1} 
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "58%" },
          padding: "1rem 2rem 2rem 2rem",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "600",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Innovation & New Product Development:{" "}
              </span>
              We can help identifying white spaces and innovation opportunities
              in your market. We provide comprehensive support, from
              understanding category and competition landscapes to developing
              innovative products and guiding market entry strategies. With our
              expertise in pricing, portfolio decisions, and full launch-mix
              development, we ensure your products are market-ready and
              positioned for success.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "600",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Brand Positioning & Communication:{" "}
              </span>
              We help define and strengthen your brand through strategic brand
              positioning decisions, brand architecture, and portfolio
              strategies. Our guidance extends to advertising and copy
              development, optimizing media plans, and assessing brand equity to
              ensure your messaging resonates with your target audience.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "600",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Go-to-Market & Retail Strategy:{" "}
              </span>
              Our services include crafting efficient distribution strategies,
              expanding distribution channels, and optimizing location selection
              for physical and digital retail. We specialize in enhancing sales
              force effectiveness, selecting the right offline partners, and
              optimizing product assortments and merchandising strategies.
              Additionally, we provide guidance on channel pricing strategies
              and trade & consumer promotions to drive sales growth.
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "600",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Your Digital Decisions:{" "}
              </span>
              From crafting digital content and communication strategies to
              optimizing digital media planning, we specialize in building and
              enhancing digital brands. Our focus areas include efficient
              customer acquisition, E-commerce planning, and developing
              omnichannel strategies to maximize your online presence.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WhatwedoContent;
